<template>
  <!-- Loading -->
  <div class="vld-parent">
      <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
  </div>

  <!-- Modal close -->
  <div class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default" v-show="(deleteModal || detailModal || contractfileModal || approvalModal)" @click="deleteModal = false, detailModal = false, contractfileModal = false, approvalModal = false" />

  <!-- Form modal -->
  <vue-final-modal
    v-model="contractfileModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'add-modal bg-darkmode-base transition-colors duration-1000' : 'add-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1 v-if="showEdit">Edit Contract File</h1>
      <h1 v-else>Contract File</h1>

      <jb-button class="btn-close-modal" :icon="mdiClose" @click="contractfileModal = false" />
    </div>

    <!-- Modal content -->
    <div class="modal-content">
      <contractfile-form
        :prop-object="contractfileObject"
        :show-edit="showEdit"
        @close-modal="contractfileModal = false"
        @refresh-list="refresh"
        @reset-modal="null"
      />
    </div>
  </vue-final-modal>

  <!-- Detail modal -->
  <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="relative h-5/6 flex flex-col mx-4 md:mx-0 pb-4 w-11/12 md:w-2/3 lg:w-1/2"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Detail Contract File</h1>

      <jb-button class="btn-close-modal" :icon="mdiClose" @click="detailModal = false" />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <contractfile-detail
        :prop-object="contractfileObject"
        @close-modal="detailModal = false"
        @refresh-list="refresh"
        @reset-modal="null"
      />
    </div>
  </vue-final-modal>

  <!-- Delete Modal -->
  <vue-final-modal
    v-model="deleteModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'delete-modal bg-darkmode-base transition-colors duration-1000' : 'delete-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>{{ $t('menu.delete') }} {{ $t('menu.data') }}</h1>

      <jb-button class="btn-close-modal" :icon="mdiClose" @click="deleteModal = false" />
    </div>

    <!-- Modal content -->
    <div class="delete-content">
      <div class="warning">{{ $t('menu.warning') }}</div>

      <div class="messsage"><p>{{ $t('confirmDelete.message') }}</p></div>
    </div>

    <!-- Button action -->
    <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
      <jb-buttons class="buttons-action-submit">
        <jb-button :label="$t('finance.button.btnConfirm')" color="info" :icon="mdiTrashCan" @click="confirmDelete" class="form-submit-btn" />
        <jb-button :label="$t('finance.button.btnCancel')" outline @click="deleteModal.value = false" class="btn-reset form-noicon-btn" />
      </jb-buttons>
    </div>
  </vue-final-modal>

  <div class="shadow overflow-hidden">
    <div>
      <dl>
        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            Decree No.
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ contract.decree_no }}
          </dd>
        </div>
        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            Decree Date
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ contract.decree_date }}
          </dd>
        </div>
        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            Period End Date
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ contract.period_end_date }}
          </dd>
        </div>
      </dl>

      <!-- Contract File -->
      <card-component
        class="mt-2"
        :title="$t('Contract File')"
        :icon="mdiDatabase"
        :master="false"
        :showAdd="true"
        @add-click="addFile"
        has-table
      >
        <ag-grid-vue
          style="width: 100%; height: 40vh;"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefs"
          :pagination="true"
          :context="context"
          @grid-ready="onGridReady"
          :rowData="filteredData"
        />
      </card-component>
    </div>
  </div>

</template>
<script>
/* eslint-disable */
import axios from 'axios'
import { mdiDatabase, mdiTrashCan, mdiClose } from '@mdi/js'
import { ref, reactive, watch, watchEffect } from 'vue'
import CardComponent from '@/components/CardComponent'
import { AgGridVue } from 'ag-grid-vue3'
import ButtonMaster from '@/components/ButtonMaster'
import { useI18n } from 'vue-i18n'
import Loading from 'vue-loading-overlay'
import VuePdfEmbed from 'vue-pdf-embed'
import { useToast } from 'vue-toastification'
import JbButtons from '@/components/JbButtons'
import JbButton from '@/components/JbButton'
import Field from '@/components/Field'
import ContractfileForm from '@/views/referensi/employee/ContractFileForm'
import ContractfileDetail from '@/views/referensi/employee/ContractFileDetail'

export default {
  name: 'ClassForm',
  components: {
    Loading,
    VuePdfEmbed,
    CardComponent,
    AgGridVue,
    JbButtons,
    JbButton,
    Field,
    ButtonMaster,
    ContractfileForm,
    ContractfileDetail
  },
  props: {
    propObject: {
        type: Object,
        default: () => ({ empty: true })
    }
  },
  data: function () {
    return {
    }
  },
  emits: ['close-modal', 'submit'],
  setup (props, { emit }) {
    const titleStack = ref(['Admin', 'Forms'])
    const isLoading = ref(false)
    const { t } = useI18n()
    const toast = useToast()

    const contract = ref({})
    const showEdit = ref(false)
    const filteredData = ref([])
    const filter = reactive({
      id: '',
      employee_id: '',
      employee_contract_id: '',
      name: '',
      file: '',
      created_by: localStorage.getItem('name'),
      updated_by: localStorage.getItem('name')
    })

    const refresh = async() => {
      isLoading.value = true
      const params = {
        employee_id: contract.value.employee_id,
        employee_contract_id: contract.value.id
      }

      await axios
        .get('employeecontract-file', { params })
        .then(response => {
          isLoading.value = false
          filteredData.value = response.data.data
        }).catch(error => {
          isLoading.value = false
          console.log(error)
        })
    }

    watchEffect(() => {
      contract.value = props.propObject
      
      console.log('contract.value', contract.value)
      if(contract.value && contract.value.id){
        refresh()
      }
    })

    // Contract File
    const defaultColDef = {
      resizable: true
    }
    const columnDefs = [
      {
        field: 'id',
        headerName: t('main.action'),
        sortable: true,
        filter: true,
        minWidth: 150,
        cellRendererFramework: 'ButtonMaster'
      },
      {
        field: 'name',
        headerName: t('Name'),
        sortable: true,
        filter: true,
        minWidth: 200,
        suppressSizeToFit: true
      },
      {
        field: 'file',
        headerName: t('File'),
        sortable: true,
        filter: true,
        minWidth: 200,
        suppressSizeToFit: true
      }
    ]

    const contractfileObject = ref()
    const contractfileModal = ref(false)
    const detailModal = ref(false)
    const deleteModal = ref(false)
    
    const addFile = () => {
      contractfileModal.value = !contractfileModal.value

      filter.employee_id = contract.value.employee_id
      filter.employee_contract_id = contract.value.id
      contractfileObject.value = filter
      showEdit.value = false
    }

    const detailData = (event, kelas) => {
      detailModal.value = true

      kelas.employee_id = contract.value.employee_id
      kelas.employee_contract_id = contract.value.id
      contractfileObject.value = kelas
    }
    const editData = (event, kelas) => {
      contractfileModal.value = !contractfileModal.value

      kelas.employee_id = contract.value.employee_id
      kelas.employee_contract_id = contract.value.id
      contractfileObject.value = kelas
      showEdit.value = true
    }
    const deleteModalShow = (value) => {
      deleteModal.value = true
      deleteModal.id = value
    }
    
    const confirmDelete = () => {
      isLoading.value = true
      axios
        .delete(`employeecontract-file/${deleteModal.id}`)
        .then(response => {
          isLoading.value = false
          if (response.data.success) {
            refresh()
            deleteModal.value = false
            toast.success(t(response.data.message), {
              timeout: 5000
            })
          } else {
            toast.error(t(response.data.message), {
              timeout: 5000
            })
          }
        }).catch(error => {
          isLoading.value = false
          console.log(error)
        })
    }

    return {
      // Contract File
      defaultColDef,
      columnDefs,
      showEdit,
      filter,
      filteredData,
      refresh,
      contractfileObject,
      contractfileModal,
      detailModal,
      deleteModal,
      addFile,
      detailData,
      editData,
      deleteModalShow,
      confirmDelete,

      isLoading,
      titleStack,
      contract,
      mdiDatabase,
      mdiTrashCan,
      mdiClose,
    }
  },
  beforeMount () {
    this.context = {
      componentParent: this
    }
  },
  methods: {
    onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      const allColumnIds = []
      this.gridColumnApi.getAllColumns().forEach((column) => {
        allColumnIds.push(column.colId)
      })
      this.gridColumnApi.autoSizeColumns(allColumnIds, false)
    }
  }
}
</script>